export const IMPERSONATION_TOKEN_KEY = 'impersonationToken';
export const IMPERSONATION_RETURN_KEY = 'impersonationReturnTo';

export const getBaseAuthToken = (): string | null => localStorage.getItem('token');
export const getImpersonationToken = (): string | null => sessionStorage.getItem(IMPERSONATION_TOKEN_KEY);
export const getEffectiveAuthToken = (): string | null => getImpersonationToken() || getBaseAuthToken();

export const setBaseAuthToken = (token: string): void => localStorage.setItem('token', token);
export const setImpersonationToken = (token: string, targetId: string): void => {
  sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
  sessionStorage.setItem(IMPERSONATION_RETURN_KEY, `/admin/users?user=${encodeURIComponent(targetId)}`);
};

export const clearImpersonationToken = (): string => {
  const returnTo = sessionStorage.getItem(IMPERSONATION_RETURN_KEY) || '/admin/users';
  sessionStorage.removeItem(IMPERSONATION_TOKEN_KEY);
  sessionStorage.removeItem(IMPERSONATION_RETURN_KEY);
  return returnTo;
};

export const clearAllAuthTokens = (): void => {
  clearImpersonationToken();
  localStorage.removeItem('token');
};

export const recoverFromAuthenticationFailure = (): void => {
  if (getImpersonationToken()) {
    window.location.href = clearImpersonationToken();
    return;
  }
  localStorage.removeItem('token');
  window.location.href = '/login';
};
